import React from "react";
import { useResponsiveImage } from "../../hooks/useResponsiveImage";

interface ResponsiveImageProps {
  mediaId: string;
  mobileMediaId?: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  mediaId,
  mobileMediaId,
  alt = "",
  className = "",
  style = {},
  onClick,
}) => {
  const imageUrl = useResponsiveImage(mediaId, mobileMediaId);

  return (
    <img
      src={imageUrl}
      alt={alt}
      className={className}
      style={style}
      onClick={onClick}
    />
  );
};

export default ResponsiveImage;
